import * as React from 'react';
import { motion } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper } from './AnimateIcon';

const animations = {
  default: {
    path: {
      initial: { y: 0 },
      animate: {
        y: [0, 4, -2, 0],
        transition: { duration: 0.6, ease: 'easeInOut' },
      },
    },
    circle: {
      initial: { y: 0 },
      animate: {
        y: [0, 1, -2, 0],
        transition: { duration: 0.6, ease: 'easeInOut' },
      },
    },
  },
};

function IconComponent({ size, ...props }) {
  const { controls } = useAnimateIconContext();
  const variants = getVariants(animations);

  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <motion.path
        d="M20 21a8 8 0 0 0-16 0"
        variants={variants.path}
        initial="initial"
        animate={controls}
      />
      <motion.circle
        cx={12}
        cy={8}
        r={5}
        variants={variants.circle}
        initial="initial"
        animate={controls}
      />
    </motion.svg>
  );
}

function UserRound(props) {
  return <IconWrapper icon={IconComponent} {...props} />;
}

export { animations, UserRound, UserRound as UserRoundIcon };
